import { render, staticRenderFns } from "./ImportProject.vue?vue&type=template&id=49b719b2&scoped=true&"
import script from "./ImportProject.vue?vue&type=script&lang=js&"
export * from "./ImportProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b719b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49b719b2')) {
      api.createRecord('49b719b2', component.options)
    } else {
      api.reload('49b719b2', component.options)
    }
    module.hot.accept("./ImportProject.vue?vue&type=template&id=49b719b2&scoped=true&", function () {
      api.rerender('49b719b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/newProject/ImportProject.vue"
export default component.exports